<app-card
    [showHeader]="false"
>
    <ng-template #content>
        <div class="grid-2col_auto input-grid-gaps-small">

            @if (showHeader()) {
                <div class="font-bold">{{ prefix + 'label' | translate }}</div>
                <div></div>
            }

            <div>{{ prefix + 'allIssuedPaid' | translate }}</div>
            <app-check-or-cross [value]="allPaid()" />

            <div>{{ prefix + 'remainingPayment' | translate }}</div>
            <div>{{ remainingPayment() | formatNumber: 2: true }} Kč</div>

            <div>{{ prefix + 'overpayment' | translate }}</div>
            <div>{{ overpayment() | formatNumber: 2: true }} Kč</div>

        </div>
    </ng-template>
</app-card>
